<template>
  <div class="head w-100">
    <h2>如何定制数据</h2>
    <h3>How to customize data</h3>
  </div>
</template>

<script>
export default {
  name: 'CustomizeHead'
}
</script>

<style lang="less" scoped>
.head {
  background-image: url('~@/assets/image/process/head-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 9.375rem);
  color: #fff;
}
h2 {
  font-size: 3rem;
  margin-bottom: 2rem;
}
h3 {
  font-size: 2rem;
}
@media (max-width: 1300px) {
  .head {
    min-height: calc(100vh - 4.375rem);
  }
}
@media (max-width: 576px) {
  .head {
    height: 70vh;
  }
  h2 {
    font-size: 28px;
    margin-bottom: 1rem;
  }
  h3 {
    font-size: 14px;
  }
}
</style>
